"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var service_1 = require("../service");
var markNotificationAsUnread = function (id) {
    return (0, service_1.getService)()
        .post("/notifications/mark_as_unread", { notification: { ids: id } })
        .then(function (_a) {
        var data = _a.data;
        return data;
    });
};
exports.default = markNotificationAsUnread;
